export default function PauseIcon() {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3.5 2.91659C3.5 2.59442 3.76117 2.33325 4.08333 2.33325H5.25C5.57216 2.33325 5.83333 2.59442 5.83333 2.91659V11.0833C5.83333 11.4054 5.57216 11.6666 5.25 11.6666H4.08333C3.76117 11.6666 3.5 11.4054 3.5 11.0833V2.91659Z"
                stroke="#5A5F6A"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.16675 2.91659C8.16675 2.59442 8.42791 2.33325 8.75008 2.33325H9.91675C10.2389 2.33325 10.5001 2.59442 10.5001 2.91659V11.0833C10.5001 11.4054 10.2389 11.6666 9.91675 11.6666H8.75008C8.42791 11.6666 8.16675 11.4054 8.16675 11.0833V2.91659Z"
                stroke="#5A5F6A"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
